
import { Component, DestroyRef, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AnalyzeService } from '@services/analyze.service';
import { GlobalDataService } from '@services/global-data.service';
import _ from 'lodash';
import { ChoroplethMapComponent } from '@components/charts/choropleth-map/choropleth-map.component';
import { HeatmapComponent } from '@components/charts/heatmap/heatmap.component';
import { MapComponent } from '@components/charts/map/map.component';
import { RouteMapComponent } from '@components/charts/route-map/route-map.component';
import { OpenSidebarData } from '../../models/OpenSideBarData';

@Component({
  selector: 'app-map-wrapper',
  standalone: true,
  imports: [HeatmapComponent, ChoroplethMapComponent, MapComponent, RouteMapComponent],
  templateUrl: './map-wrapper.component.html',
  styleUrls: ['./map-wrapper.component.scss'],
})
export class MapWrapperComponent implements OnInit {
    @Output() openSidebar = new EventEmitter<OpenSidebarData>();

    data: any;
    private analyzeView: string;
    analyzeData: any;
    private readonly destroyRef = inject(DestroyRef);

    constructor(
    private analyzeService: AnalyzeService,
    private globalDataService: GlobalDataService
    ) {
    }

    ngOnInit(): void {
      this.analyzeService.getAnalyzeData()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((res) => {
          this.analyzeData = null;
          this.data = null;
          setTimeout(() => {
            this.analyzeData = _.cloneDeep(res);
            this.init();
          }, 0);
        });
      this.globalDataService.getMattermapViewNgx()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((view) => {
          this.analyzeView = view;
          if (this.analyzeData && this.analyzeData.nodes) {
            this.init();
          }
        });
    }
    init() {
      if (!this.analyzeData) return;
      switch (this.analyzeView) {
        case 'choropleth':
          this.data = {
            mapData: this.analyzeData.choropleth,
            type: 'choropleth-map'
          };
          break;
        case 'heatmap':
          this.data = {
            mapData: this.analyzeData.heatmap,
            type: 'heat-map'
          };
          break;
        case 'pinmap':
          this.data = {
            type: 'pin-map',
            controls: true,
            controller: 'network-graph',
            mapData: this.analyzeData.pinmap
          };
          break;
        case 'routemap':
          this.data = {
            type: 'route-map',
            rid: this.analyzeService.getAnalyzeRid(),
            layer: this.analyzeService.getLayer()
          };
          break;

        default:
          break;
      }
    }

    onOpenSidebar(event: OpenSidebarData): void {
      this.openSidebar.emit(event);
    }
}
